var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
function handleSpecialObjects(value) {
  if (value instanceof Response) {
    return extractResponse(value);
  }
  if (value instanceof Error) {
    return extractError(value);
  }
  if (value instanceof Map) {
    return extractMap(value);
  }
  if (value instanceof Set) {
    return extractSet(value);
  }
  if (value instanceof Promise) {
    return "Promise";
  }
  return recursiveExtract(value);
}
function extractResponse(response) {
  return {
    status: response.status,
    statusText: response.statusText,
    url: response.url,
    headers: [...response.headers.entries()],
    bodyUsed: response.bodyUsed,
    ok: response.ok,
    redirected: response.redirected,
    type: response.type
  };
}
function extractError(error) {
  return {
    message: error.message,
    stack: error.stack,
    name: error.name
  };
}
function extractMap(map) {
  return {
    type: "Map",
    entries: [...map.entries()]
  };
}
function extractSet(set) {
  return {
    type: "Set",
    values: [...set.values()]
  };
}
function serializeObject(error) {
  return recursiveExtract(error);
}
function doNotExtract(value) {
  return typeof value === "string" || typeof value === "number" || typeof value === "boolean" || typeof value === "symbol" || typeof value === "bigint" || typeof value === "function" || value === null || value === void 0;
}
function recursiveExtract(error) {
  if (error === null || error === void 0) {
    return error;
  }
  try {
    if (Array.isArray(error)) {
      return error.map(
        (item) => doNotExtract(item) ? item : recursiveExtract(item)
      );
    }
    let extracted = {};
    const properties = Object.getOwnPropertyNames(error);
    for (const key of properties) {
      const value = error[key];
      if (doNotExtract(value)) {
        extracted[key] = value;
      } else if (typeof value === "object") {
        extracted[key] = Object.keys(value).length === 0 ? {} : handleSpecialObjects(value);
      }
    }
    return extracted;
  } catch (e) {
    return error;
  }
}
class Logger {
  /**
   * Creates an instance of Logger.
   * @param isLocal - Indicates if the logger should log to console (true) or Datadog (false).
   * @param datadogLogger - The datadogLogs instance to use for logging.
   */
  constructor(isLocal, datadogLogger) {
    __publicField(this, "isLocal");
    __publicField(this, "datadogLogger");
    this.isLocal = isLocal;
    this.datadogLogger = datadogLogger;
  }
  /**
   * Logs a message with a specified log level and optional object.
   * @param message - The message to log.
   * @param level - The log level ('info', 'warn', 'error').
   * @param object - Optional object to log.
   */
  log(message, level = "info", object) {
    if (this.isLocal) {
      this.consoleLog(message, level, object);
    } else {
      this.datadogLog(message, level, object);
    }
  }
  /**
   * Logs an info message.
   * @param message - The message to log.
   * @param object - Optional object to log.
   */
  info(message, object) {
    this.log(message, "info", object);
  }
  /**
   * Logs a warning message.
   * @param message - The message to log.
   * @param object - Optional object to log.
   */
  warn(message, object) {
    this.log(message, "warn", object);
  }
  /**
   * Logs an error message.
   * @param message - The message to log.
   * @param object - Optional object to log.
   */
  error(message, object) {
    this.log(message, "error", object);
  }
  /**
   * Sets the context for the Datadog logger.
   * @param context - The context to set.
   */
  setContext(context) {
    if (this.datadogLogger) {
      this.datadogLogger.setContext(context);
    } else {
      console.warn("Datadog logger instance is not defined");
    }
  }
  consoleLog(message, level, object) {
    if (object) {
      console[level](message, { logData: serializeObject(object) });
    } else {
      console[level](message);
    }
  }
  datadogLog(message, level, object) {
    if (this.datadogLogger) {
      const logData = object ? { logData: serializeObject(object) } : {};
      this.datadogLogger[level](message, logData);
    } else {
      console.warn("Datadog logs instance is not defined");
    }
  }
}
export {
  Logger
};
